// extracted by mini-css-extract-plugin
export var container = "_av-1";
export var cornerButtonContainer = "_av-5";
export var disabled = "_av-2";
export var fileContainer = "_av-4";
export var hiddenInput = "_av-3";
export var widthContainer = "_av-0";